import { remove as diacriticsRemove } from 'diacritics';
import fromPairs from 'lodash-es/fromPairs';

export function simpleEnum(array) {
    return fromPairs(array.map((item) => [item, item]));
}

export function slugify(s: string) {
    if (!s) {
        return '';
    }

    return diacriticsRemove(s.trim().toLowerCase())
        .replace(/[,/.´]/g, ' ') // Replace spaces
        .replace(/[^\w\s-]/g, '') // Replace non characters
        .replace(/[-\s]+/g, '-') // Shrink multiple -
        .replace(/^-+/, '') // Trim from start
        .replace(/-+$/, ''); // Trim from end
}

export const SMILEYS = {
    ':-)': 'slight_smile',
    ':)': 'slight_smile',
    ';-)': 'wink',
    ':-(': 'frowning2',
    ':-|': 'unamused',
    ']-(': 'angry',
    '8-)': 'sunglasses',
    ':-S': 'confounded',
    ':-o': 'astonished',
    ';-(': 'cry',
    ':-D': 'grinning',
    ':-p': 'stuck_out_tongue_closed_eyes',
    '|-|': 'pensive',
    ':-N': 'sweat_smile',
    '=-)': 'confused',
    '8-(': 'rolling_eyes',
    ':-.': 'fearful',
    ':-x': 'zipper_mouth',
    'x-)': 'dizzy_face',
};

export function isPureEmojiShortcodes(text) {
    if (text.length === 0) {
        return false;
    }
    const rest = text.replace(/:\w+:/g, (match) => '');
    return rest.length <= 0;
}

export function detectDeviceOS(userAgent) {
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
        // IE11 will pass as an iOS device in this test too
        // For completeness, && !window.MSStream is needed
        // but we don't have 'window' object here
        // (can be running on server in nodejs)
        return 'iOS';
    }

    return 'unknown';
}
